import ArrowSvg from "../../assets/svg/arrowSvg";
import "./TierComponent.css";

const defaultProps = {
  tierName: "",
  mostPopular: true,
  monthlyPrice: "$5.99",
  tierHighlights: [{ isPositive: true, text: "" }],
  disabled: false,
};

function TierComponent(props = defaultProps) {
  return (
    <section className="tier-component">
      <div className="tier-name-container">
        <h3 className="tier-name">{props.tierName}</h3>
      </div>

      {/* most popular */}
      {props.mostPopular && <div className="most-popular">Most Popular 🔥</div>}

      <div className="tier-pricing-container">
        <h2 className="monthly-price">{props.monthlyPrice} Monthly</h2>
      </div>

      <div className="tier-highlights-container">
        <ul>
          {props.tierHighlights.map((highlight, index) => {
            if (highlight.isPositive) {
              return (
                <li key={index} className="tier-highlight">
                  {highlight.text}
                </li>
              );
            } else {
              return (
                <li key={index} className="tier-highlight negative">
                  {highlight.text}
                </li>
              );
            }
          })}
        </ul>
      </div>

      <button disabled={props.disabled ?? false} className="standard-button tier-button" onClick={props.onClick}>
        {props.buttonText}
        <ArrowSvg class="tier-arrow"></ArrowSvg>
      </button>
    </section>
  );
}

export default TierComponent;
